import React from 'react';

import { ConfigProvider } from 'antd';

import App from './app/App';
import './assets/index.css';
import reportWebVitals from './reportWebVitals';
import { DEFAULT_THEME } from './theme';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { store } from '@store/index';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

const container = document.getElementById('root')!;
const root = createRoot(container);

library.add(fas);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider theme={DEFAULT_THEME}>
        <App></App>
      </ConfigProvider>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
